import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';

/**
 * fof/upload shows its own alert only for errors with an "fof-upload…" code and rethrows the
 * rest, so a rejected file type (core validation_error) or a file over the web server's body
 * limit (413, not JSON) ends up as Flarum's generic "something went wrong" message.
 * The upload logic is untouched; only the failure is turned into a clear alert.
 */
export default function addUploadErrors() {
  override('ext:fof/upload/forum/handler/Uploader', 'upload', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return original(...args).catch(error => {
      this.uploading = false;

      // the server's own detail is technical ("MIME type mismatch detected: …"): readers get the plain line
      const message = error?.status === 413 ? app.translator.trans('tarotportal-theme.forum.upload.too_large', {}, true) : app.translator.trans('tarotportal-theme.forum.upload.failed', {}, true);
      app.alerts.clear();
      app.alerts.show({
        type: 'error'
      }, message);
      m.redraw();
    });
  });
}